import React, { useState } from "react";
import { Button, Input } from "antd";
import "../auth-common.css";
import { useNavigate } from "react-router-dom";
import { SuccessToast } from "../../widgets/AppToast";
import { post } from "../../services/services";
import { ApiURL } from "../../services/apiConstants";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [adminEmail, setAdminEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});

  const forgotPassword = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("email", adminEmail);
    try {
      const res = await post(ApiURL.forgot_view, formData);
      if (res?.status === true) {
        SuccessToast(
          "Success!!",
          "Your Set Password OTP is successfully sent to your email address."
        );
        navigate("/otp-verification/" + btoa(adminEmail) + "/" + btoa("forgot_password"));
      } else {
        setErrors(res?.response?.data?.errors || {});
      }
    } catch (error) {
      setErrors({ catch: ["An error occurred. Please try again."] });
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-glass-card">
        <div className="auth-header">
          <h5>MarinBytes - Data, Ships, People and Sustainability</h5>
          <h2>Forgot Password</h2>
        </div>
        <div className="auth-body">
          {errors?.try && <span style={{ color: "red", display: 'block', marginBottom: '10px' }}>{errors.try[0]}</span>}
          {errors?.catch && <span style={{ color: "red", display: 'block', marginBottom: '10px' }}>{errors.catch[0]}</span>}
          <div className="auth-input-group">
            <label>Registered Email Address</label>
            <Input
              size="large"
              placeholder="e.g. name@example.com"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
            />
            {errors?.email && <span style={{ color: "red", fontSize: '12px' }}>{errors.email}</span>}
          </div>
          <Button 
            loading={loader} 
            className="auth-primary-btn" 
            type="primary" 
            onClick={forgotPassword}
          >
            Send OTP
          </Button>

          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <span className="auth-link-btn" onClick={() => navigate("/")}>
              Back to Login
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
